export const SLIDER_MARKS = {
  0: 0,
  7500000: 7500000,
  15000000: 15000000,
};
